<template>
  <div class="footer">
    <div class="ng-footer-v4">
            <div class="footer-content-wrapper-v4">
                <div class="logo-content-wrapper">
                    <a href="https://www.cgtn.com" class="logo-content"></a>
                </div>
                <div class="NEWSPAL-wrapper">
                    <div class="search-area">
                        <div class="search-wrapper">
                            <input class="search-input" placeholder="Ask or search">
                            <div class="search-button">
                                <div class="NEWSPAL-logo">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer-nav-wrapper">
                    <div class="footer-nav-top">
                        <div class="footer-nav-top-item-wrapper">
                            <a href="https://www.cgtn.com" class="footer-nav-top-item Home-item" target="_self"
                                data-category="Home" data-list="" data-action="Nav_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                Home
                            </a>
                        </div>
                        <div class="footer-nav-top-item-wrapper">
                            <a href="https://www.cgtn.com/china" class="footer-nav-top-item China-item" target="_self"
                                data-category="Home" data-list="" data-action="Nav_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                China
                            </a>
                        </div>
                        <div class="footer-nav-top-item-wrapper">
                            <a href="https://www.cgtn.com/world" class="footer-nav-top-item World-item" target="_self"
                                data-category="Home" data-list="" data-action="Nav_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                World
                            </a>
                        </div>
                        <div class="footer-nav-top-item-wrapper">
                            <a href="https://www.cgtn.com/politics" class="footer-nav-top-item Politics-item"
                                target="_self" data-category="Home" data-list="" data-action="Nav_Click" data-label=""
                                data-position="" data-index="" data-news-id="" data-time="">
                                Politics
                            </a>
                        </div>
                        <div class="footer-nav-top-item-wrapper">
                            <a href="https://www.cgtn.com/business" class="footer-nav-top-item Business-item"
                                target="_self" data-category="Home" data-list="" data-action="Nav_Click" data-label=""
                                data-position="" data-index="" data-news-id="" data-time="">
                                Business
                            </a>
                        </div>
                        <div class="footer-nav-top-item-wrapper">
                            <a href="https://www.cgtn.com/sci-tech" class="footer-nav-top-item Sci-Tech-item"
                                target="_self" data-category="Home" data-list="" data-action="Nav_Click" data-label=""
                                data-position="" data-index="" data-news-id="" data-time="">
                                Sci-Tech
                            </a>
                        </div>
                        <div class="footer-nav-top-item-wrapper">
                            <a href="https://www.cgtn.com/health" class="footer-nav-top-item Health-item" target="_self"
                                data-category="Home" data-list="" data-action="Nav_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                Health
                            </a>
                        </div>
                        <div class="footer-nav-top-item-wrapper">
                            <a href="https://www.cgtn.com/culture" class="footer-nav-top-item Culture-item"
                                target="_self" data-category="Home" data-list="" data-action="Nav_Click" data-label=""
                                data-position="" data-index="" data-news-id="" data-time="">
                                Culture
                            </a>
                        </div>
                        <div class="footer-nav-top-item-wrapper">
                            <a href="https://www.cgtn.com/nature" class="footer-nav-top-item Nature-item" target="_self"
                                data-category="Home" data-list="" data-action="Nav_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                Nature
                            </a>
                        </div>
                        <div class="footer-nav-top-item-wrapper">
                            <a href="https://www.cgtn.com/travel" class="footer-nav-top-item Travel-item" target="_self"
                                data-category="Home" data-list="" data-action="Nav_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                Travel
                            </a>
                        </div>
                        <div class="footer-nav-top-item-wrapper">
                            <a href="https://www.cgtn.com/sports" class="footer-nav-top-item Sports-item" target="_self"
                                data-category="Home" data-list="" data-action="Nav_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                Sports
                            </a>
                        </div>
                        <div class="footer-nav-top-item-wrapper">
                            <a href="https://www.cgtn.com/live" class="footer-nav-top-item Live-item" target="_self"
                                data-category="Home" data-list="" data-action="Nav_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                Live
                            </a>
                        </div>
                        <div class="footer-nav-top-item-wrapper">
                            <a href="https://www.cgtn.com/opinions" class="footer-nav-top-item Opinions-item"
                                target="_self" data-category="Home" data-list="" data-action="Nav_Click" data-label=""
                                data-position="" data-index="" data-news-id="" data-time="">
                                Opinions
                            </a>
                        </div>
                        <div class="footer-nav-top-item-wrapper">
                            <a href="https://www.cgtn.com/documentary" class="footer-nav-top-item Documentary-item"
                                target="_self" data-category="Home" data-list="" data-action="Nav_Click" data-label=""
                                data-position="" data-index="" data-news-id="" data-time="">
                                Documentary
                            </a>
                        </div>
                        <div class="footer-nav-top-item-wrapper">
                            <a href="https://www.cgtn.com/gstringer" class="footer-nav-top-item Global Stringer-item"
                                target="_self" data-category="Home" data-list="" data-action="Nav_Click" data-label=""
                                data-position="" data-index="" data-news-id="" data-time="">
                                Global Stringer
                            </a>
                        </div>
                        <div class="footer-nav-top-item-wrapper">
                            <a href="https://www.cgtn.com/clab" class="footer-nav-top-item Creative Lab-item"
                                target="_self" data-category="Home" data-list="" data-action="Nav_Click" data-label=""
                                data-position="" data-index="" data-news-id="" data-time="">
                                Creative Lab
                            </a>
                        </div>
                        <div class="footer-nav-top-item-wrapper">
                            <a href="https://www.cgtn.com/v-studio" class="footer-nav-top-item Art &amp; Design-item"
                                target="_self" data-category="Home" data-list="" data-action="Nav_Click" data-label=""
                                data-position="" data-index="" data-news-id="" data-time="">
                                Art &amp; Design
                            </a>
                        </div>
                        <div class="footer-nav-top-item-wrapper">
                            <a href="https://radio.cgtn.com" class="footer-nav-top-item Radio-item" target="_self"
                                data-category="Home" data-list="" data-action="Nav_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                Radio
                            </a>
                        </div>
                        <div class="footer-nav-top-item-wrapper">
                            <a href="https://www.cgtn.com/video" class="footer-nav-top-item Video-item" target="_self"
                                data-category="Home" data-list="" data-action="Nav_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                Video
                            </a>
                        </div>
                        <div class="footer-nav-top-item-wrapper">
                            <a href="https://chatgroup.user.cgtn.com/share/index.html"
                                class="footer-nav-top-item Chat Group-item" target="_self" data-category="Home"
                                data-list="" data-action="Nav_Click" data-label="" data-position="" data-index=""
                                data-news-id="" data-time="">
                                Chat Group
                            </a>
                        </div>
                        <div class="footer-nav-top-item-wrapper">
                            <a href="https://www.cgtn.com/specials" class="footer-nav-top-item Specials-item"
                                target="_self" data-category="Home" data-list="" data-action="Nav_Click" data-label=""
                                data-position="" data-index="" data-news-id="" data-time="">
                                Specials
                            </a>
                        </div>
                        <div class="footer-nav-top-item-wrapper">
                            <a href="https://www.cgtn.com/transcript" class="footer-nav-top-item Transcript-item"
                                target="_self" data-category="Home" data-list="" data-action="Nav_Click" data-label=""
                                data-position="" data-index="" data-news-id="" data-time="">
                                Transcript
                            </a>
                        </div>
                        <div class="footer-nav-top-item-wrapper">
                            <a href="https://www.cgtn.com/special/chinese-master"
                                class="footer-nav-top-item Learn Chinese-item" target="_self" data-category="Home"
                                data-list="" data-action="Nav_Click" data-label="" data-position="" data-index=""
                                data-news-id="" data-time="">
                                Learn Chinese
                            </a>
                        </div>
                        <div class="footer-nav-top-item-wrapper">
                            <a href="https://ask-china.cgtn.com/" class="footer-nav-top-item Ask China-item"
                                target="_self" data-category="Home" data-list="" data-action="Nav_Click" data-label=""
                                data-position="" data-index="" data-news-id="" data-time="">
                                Ask China
                            </a>
                        </div>
                    </div>
                </div>
                <div class="EXPLORE-MORE-wrapper">
                    <div class="EXPLORE-MORE-title">
                        EXPLORE MORE
                    </div>
                    <div class="EXPLORE-MORE-content" id="language">
                        <div class="exploremore-item-wrapper">
                            <a href="https://www.cgtn.com/tv" class="exploremore-item" target="_self"
                                data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                data-position="" data-index="" data-news-id="" data-time="">
                                English
                            </a>
                        </div>
                        <div class="exploremore-item-wrapper">
                            <a href="//espanol.cgtn.com" class="exploremore-item" target="_self" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                Español
                            </a>
                        </div>
                        <div class="exploremore-item-wrapper">
                            <a href="//francais.cgtn.com" class="exploremore-item" target="_self" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                Français
                            </a>
                        </div>
                        <div class="exploremore-item-wrapper">
                            <a href="//arabic.cgtn.com" class="exploremore-item" target="_self" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                العربية
                            </a>
                        </div>
                        <div class="exploremore-item-wrapper">
                            <a href="//russian.cgtn.com" class="exploremore-item" target="_self" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                Русский
                            </a>
                        </div>
                        <div class="exploremore-item-wrapper">
                            <a href="https://www.cgtn.com/channel/documentary" class="exploremore-item" target="_self"
                                data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                data-position="" data-index="" data-news-id="" data-time="">
                                Documentary
                            </a>
                        </div>
                        <div class="exploremore-item-wrapper">
                            <a href="http://www.cctvplus.com" class="exploremore-item" target="_self"
                                data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                data-position="" data-index="" data-news-id="" data-time="">
                                CCTV+
                            </a>
                        </div>
                    </div>
                </div>
                <div class="choose-your-language-wrapper">
                    <div class="choose-your-language-title">
                        CHOOSE YOUR LANGUAGE
                    </div>
                    <div class="choose-your-language-content">
                        <div class="lang-item-wrapper">
                            <a href="https://albanian.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Albanian</div>
                                <div class="lang-name2">Shqip</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="//arabic.cgtn.com" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Arabic</div>
                                <div class="lang-name2">العربية</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://belarusian.cgtn.com/" class="lang-item" target="_blank"
                                data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                data-position="" data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Belarusian</div>
                                <div class="lang-name2">Беларуская</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://bangla.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Bengali</div>
                                <div class="lang-name2">বাংলা</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://bulgarian.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Bulgarian</div>
                                <div class="lang-name2">Български</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://cambodian.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Cambodian</div>
                                <div class="lang-name2">ខ្មែរ</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://croatian.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Croatian</div>
                                <div class="lang-name2">Hrvatski</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://czech.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Czech</div>
                                <div class="lang-name2">Český</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://www.cgtn.com/tv" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">English</div>
                                <div class="lang-name2">English</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://esperanto.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Esperanto</div>
                                <div class="lang-name2">Esperanto</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://filipino.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Filipino</div>
                                <div class="lang-name2">Filipino</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="//francais.cgtn.com" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">French</div>
                                <div class="lang-name2">Français</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://german.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">German</div>
                                <div class="lang-name2">Deutsch</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://greek.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Greek</div>
                                <div class="lang-name2">Ελληνικά</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://hausa.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Hausa</div>
                                <div class="lang-name2">Hausa</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://hebrew.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Hebrew</div>
                                <div class="lang-name2">עברית</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://hungarian.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Hungarian</div>
                                <div class="lang-name2">Magyar</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://hindi.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Hindi</div>
                                <div class="lang-name2">हिन्दी</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://indonesian.cgtn.com/" class="lang-item" target="_blank"
                                data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                data-position="" data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Indonesian</div>
                                <div class="lang-name2">Bahasa Indonesia</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://italian.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Italian</div>
                                <div class="lang-name2">Italiano</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://japanese.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Japanese</div>
                                <div class="lang-name2">日本語</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://korean.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Korean</div>
                                <div class="lang-name2">한국어</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://laos.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Lao</div>
                                <div class="lang-name2">ລາວ</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://malay.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Malay</div>
                                <div class="lang-name2">Bahasa Melayu</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://mongol.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Mongolian</div>
                                <div class="lang-name2">Монгол</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://myanmar.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Myanmar</div>
                                <div class="lang-name2">မြန်မာဘာသာ</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://nepal.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Nepali</div>
                                <div class="lang-name2">नेपाली</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://persian.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Persian</div>
                                <div class="lang-name2">فارسی</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://polish.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Polish</div>
                                <div class="lang-name2">Polski</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://portuguese.cgtn.com/" class="lang-item" target="_blank"
                                data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                data-position="" data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Portuguese</div>
                                <div class="lang-name2">Português</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://pashto.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Pashto</div>
                                <div class="lang-name2">پښتو</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://romanian.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Romanian</div>
                                <div class="lang-name2">Română</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="//russian.cgtn.com" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Russian</div>
                                <div class="lang-name2">Русский</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://serbian.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Serbian</div>
                                <div class="lang-name2">Српски</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://sinhala.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Sinhalese</div>
                                <div class="lang-name2">සිංහල</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="//espanol.cgtn.com" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Spanish</div>
                                <div class="lang-name2">Español</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://swahili.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Swahili</div>
                                <div class="lang-name2">Kiswahili</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://tamil.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Tamil</div>
                                <div class="lang-name2">தமிழ்</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://thai.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Thai</div>
                                <div class="lang-name2">ไทย</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://turkish.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Turkish</div>
                                <div class="lang-name2">Türkçe</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://ukrainian.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Ukrainian</div>
                                <div class="lang-name2">Українська</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://urdu.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Urdu</div>
                                <div class="lang-name2">اردو</div>
                            </a>
                        </div>
                        <div class="lang-item-wrapper">
                            <a href="https://vietnamese.cgtn.com/" class="lang-item" target="_blank"
                                data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                data-position="" data-index="" data-news-id="" data-time="">
                                <div class="lang-name1">Vietnamese</div>
                                <div class="lang-name2">Tiếng Việt</div>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="follow-us-wrapper">
                    <div class="follow-us-title">
                        FOLLOW CGTN
                    </div>
                    <div class="follow-us-content">
                        <div class="share-item-wrapper">
                            <a href="https://www.facebook.com/ChinaGlobalTVNetwork" class="icon fb cg-com-sprite"
                                target="_blank" data-category="Home" data-list="" data-action="Socialmedia_Click"
                                data-label="" data-position="" data-index="" data-news-id="" data-time="">
                            </a>
                        </div>
                        <div class="share-item-wrapper">
                            <a href="https://twitter.com/CGTNOfficial" class="icon twitter cg-com-sprite"
                                target="_blank" data-category="Home" data-list="" data-action="Socialmedia_Click"
                                data-label="" data-position="" data-index="" data-news-id="" data-time="">
                            </a>
                        </div>
                        <div class="share-item-wrapper">
                            <a href="https://www.youtube.com/CGTN" class="icon youtube cg-com-sprite" target="_blank"
                                data-category="Home" data-list="" data-action="Socialmedia_Click" data-label=""
                                data-position="" data-index="" data-news-id="" data-time="">
                            </a>
                        </div>
                        <div class="share-item-wrapper">
                            <a href="https://www.instagram.com/cgtn" class="icon ins cg-com-sprite" target="_blank"
                                data-category="Home" data-list="" data-action="Socialmedia_Click" data-label=""
                                data-position="" data-index="" data-news-id="" data-time="">
                            </a>
                        </div>
                        <div class="share-item-wrapper">
                            <a href="https://www.pinterest.com/CGTNOfficial" class="icon pinterest cg-com-sprite"
                                target="_blank" data-category="Home" data-list="" data-action="Socialmedia_Click"
                                data-label="" data-position="" data-index="" data-news-id="" data-time="">
                            </a>
                        </div>
                        <div class="share-item-wrapper">
                            <a href="https://www.quora.com/profile/CGTN-Social-Team" class="icon quora cg-com-sprite"
                                target="_blank" data-category="Home" data-list="" data-action="Socialmedia_Click"
                                data-label="" data-position="" data-index="" data-news-id="" data-time="">
                            </a>
                        </div>
                        <div class="share-item-wrapper">
                            <a href="https://www.linkedin.com/company/cgtn" class="icon linkedin cg-com-sprite"
                                target="_blank" data-category="Home" data-list="" data-action="Socialmedia_Click"
                                data-label="" data-position="" data-index="" data-news-id="" data-time="">
                            </a>
                        </div>
                        <div class="share-item-wrapper">
                            <a href="https://www.threads.com/@cgtn" class="icon threads cg-com-sprite" target="_blank"
                                data-category="Home" data-list="" data-action="Socialmedia_Click" data-label=""
                                data-position="" data-index="" data-news-id="" data-time="">
                            </a>
                        </div>
                        <div class="share-item-wrapper">
                            <a href="https://t.me/CGTNOfficial_BJ" class="icon telegram cg-com-sprite" target="_blank"
                                data-category="Home" data-list="" data-action="Socialmedia_Click" data-label=""
                                data-position="" data-index="" data-news-id="" data-time="">
                            </a>
                        </div>
                        <div class="share-item-wrapper">
                            <a href="https://v.douyin.com/2VMKvpC" class="icon douyin cg-com-sprite" target="_blank"
                                data-category="Home" data-list="" data-action="Socialmedia_Click" data-label=""
                                data-position="" data-index="" data-news-id="" data-time="">
                            </a>
                        </div>
                        <div class="share-item-wrapper">
                            <a href="http://weibo.com/cctvnewsbeijing" class="icon weibo cg-com-sprite" target="_blank"
                                data-category="Home" data-list="" data-action="Socialmedia_Click" data-label=""
                                data-position="" data-index="" data-news-id="" data-time="">
                            </a>
                        </div>
                        <div class="share-item-wrapper">
                            <div class="wechat-share-footer">
                                <a href="javascript:;" class="icon wechat cg-com-sprite" target="_self"
                                    data-category="Home" data-list="" data-action="Socialmedia_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                </a>
                                <div class="footer-v4-wechat J-footer-v4-wechat">
                                    <img src="https://ui.cgtn.com/ui/attention/attention.jpg" width="150">
                                </div>
                            </div>
                        </div>
                        <div class="share-item-wrapper">
                            <a href="https://www.toutiao.com/c/user/82615367134/#mid=1588042509127693"
                                class="icon toutiao cg-com-sprite" target="_blank" data-category="Home" data-list=""
                                data-action="Socialmedia_Click" data-label="" data-position="" data-index=""
                                data-news-id="" data-time="">
                            </a>
                        </div>
                    </div>
                </div>
                <div class="footer-bottom-wrapper">
                    <div class="download-title">DOWNLOAD OUR APP</div>
                    <div class="download-logos">
                        <a href="https://itunes.apple.com/us/app/cctvnews/id922456579" class="downicon apple"
                            target="_blank" data-category="Home" data-list="" data-action="Download_Click" data-label=""
                            data-position="" data-index="" data-news-id="" data-time="">
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=com.imib.cctv" class="downicon google"
                            target="_blank" data-category="Home" data-list="" data-action="Download_Click" data-label=""
                            data-position="" data-index="" data-news-id="" data-time="">
                        </a>
                        <a href="//news.cgtn.com/download/CGTN.apk" class="downicon web" target="_blank"
                            data-category="Home" data-list="" data-action="Download_Click" data-label=""
                            data-position="" data-index="" data-news-id="" data-time="">
                        </a>
                        <a href="https://www.cgtn.com/appletv-download" class="downicon apple-tv" target="_blank"
                            data-category="Home" data-list="" data-action="Download_Click" data-label=""
                            data-position="" data-index="" data-news-id="" data-time="">
                        </a>
                    </div>
                    <div class="TCPA-wrapper">
                        <a href="https://www.cgtn.com/terms-of-use" class="terms-of-use" target="_self"
                            data-category="Home" data-list="" data-action="TeamOfUs_Click" data-label=""
                            data-position="" data-index="" data-news-id="" data-time="">
                            Terms of use
                        </a>
                        <a href="https://www.cgtn.com/copyright" class="copyright" target="_self" data-category="Home"
                            data-list="" data-action="Copyright_Click" data-label="" data-position="" data-index=""
                            data-news-id="" data-time="">
                            Copyright
                        </a>
                        <a href="https://www.cgtn.com/privacy" class="privacy" target="_self" data-category="Home"
                            data-list="" data-action="PrivacyPolicy_Click" data-label="" data-position="" data-index=""
                            data-news-id="" data-time="">
                            Privacy policy
                        </a>
                        <a href="https://www.cgtn.com/about-us" class="about-us" target="_self" data-category="Home"
                            data-list="" data-action="AboutUs_Click" data-label="" data-position="" data-index=""
                            data-news-id="" data-time="">
                            About us
                        </a>
                    </div>
                    <div class="copy-common-wrapper-v4">
                        <div class="copy-right-wrapper">
                            <div class="copy-right-text">Copyright © 2026 CGTN. </div>
                            <a class="copy-right-link" href="http://beian.miit.gov.cn"
                                target="_blank">京ICP备20000184号</a>
                        </div>
                        <div class="copy-common-wrapper">
                            <div class="copy-common-content">
                                <a class="copy-common-text"
                                    href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502050052"
                                    target="_blank">
                                    <img src="https://ui.cgtn.com/static/ng/resource/images/gwab.png"
                                        class="gwab-img-v4">
                                    <div class="jgwab-num-v4">京公网安备 11010502050052号</div>
                                </a>
                                <div class="copy-able-text">互联网新闻信息许可证10120180008</div>
                            </div>
                            <div class="copy-hotline">Disinformation report hotline: 010-85061466<p></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="IphoneHome hidden-lg hidden-md hidden-sm" id="IphoneHome">

                <div class="iphoneBg"></div>
                <span class="iphhome_close" id="iphhome_close"></span>
                <input class="weixinUrl" name="weixinUrl" type="hidden" value="https://www.cgtn.com">
                <input class="firstNews" name="firstNews" type="hidden"
                    value="https://news.cgtn.com/news/2026-01-05/President-Xi-holds-talks-with-ROK-President-Lee-Jae-Myung-1JGDnh71xSw/p.html">
            </div>
        </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      msg: 'footer'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .footer{
    margin-top: 20px;
  }
  .noMargin{
    margin-top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer_v4.vue